import React from "react";
import ReactDOM from "react-dom/client";
import "./GradeLookup.css";
import GradeLookup from "./GradeLookup";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <GradeLookup />
  </React.StrictMode>
);
